module.exports = __webpack_public_path__ + "static/media/bg_flow.eae09ee5.png";